import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import Swal from 'sweetalert2';
import { NgbModal, NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { DataService } from '../data/data.service';
import { Student } from '../data/student';
import { Assessment, StudentAssessmentDetails } from '../data/assessments';
import { BaseComponent } from '../base/base.component';
import { ActivatedRoute, Router } from '@angular/router';
import { RedirectService } from '../redirect.service';
import { OrganizationService } from '../organization.service';
import { Location } from '@angular/common';
import { AuthService } from '../auth.service';
import { ISortOrder } from '../sort-toggle/sort-toggle.component';

@Component({
  selector: 'app-class-assessment-details-modal',
  templateUrl: './class-assessment-details-modal.component.html',
  styleUrls: ['./class-assessment-details-modal.component.scss']
})

export class ClassAssessmentDetailsModalComponent extends BaseComponent implements OnInit {
  constructor(
    protected route: ActivatedRoute,
    protected authService: AuthService,
    protected organizationService: OrganizationService,
    protected redirectService: RedirectService,
    protected router: Router,
    protected dataService: DataService,
    protected location: Location,
    private modalService: NgbModal
  ) {
    super(route, authService, organizationService, redirectService, router, dataService, location);
  }

  @ViewChild('modal') modal: NgbActiveModal;
  @Output() dataRefresh = new EventEmitter();
  @Output() openRequestModal = new EventEmitter<number>();

  @Input() assessment: Assessment;
  @Input() studentAssessmentDetails: StudentAssessmentDetails[];
  @Input() className: string;

  get assessmentName(): string { return this.assessment.Title }

  modalRef: NgbModalRef;

  open() {
    this.modalRef = this.modalService.open(this.modal, { size: 'xl' });
  }

  updateSort(sortOrder: ISortOrder) {
    this.studentAssessmentDetails.sort((a, b) => {
      var sortVal =
        sortOrder.orderBy === 'StudentName' ? this.sortString(a.StudentName, b.StudentName) :
          sortOrder.orderBy === 'Status' ? this.sortStatus(a, b) :
            sortOrder.orderBy === 'NumAttempts' ? this.sortNumbers(a.NumAttempts, b.NumAttempts) :
              sortOrder.orderBy === 'LastAttempt' ? this.sortDate(a.CompletedAt, b.CompletedAt) :
                sortOrder.orderBy === 'NumCorrect' ? this.sortNumbers(this.getNumCorrect(a), this.getNumCorrect(b)) :
                  sortOrder.orderBy === 'NumIncorrect' ? this.sortNumbers(this.getNumIncorrect(a), this.getNumIncorrect(b)) :
                    this.sortString(a.StudentName, b.StudentName);
      if (!sortOrder.ascending) sortVal *= -1;
      return sortVal;
    });
  }

  sortStatus(a, b) {
    var aVal = a.Passed;
    var bVal = b.Passed;

    if (aVal === null || aVal === undefined) return 1;
    if (bVal === null || bVal === undefined) return -1;

    if (aVal === true && bVal === false) return -1;
    if (aVal === false && bVal === true) return 1;

    return 0;
  }

  sortDate(a, b) {
    let aCompleted, bCompleted;

    if (!a || !a.CompletedAt) aCompleted = 0;
    else aCompleted = new Date(a.CompletedAt).getTime();

    if (!b || !b.CompletedAt) bCompleted = 0;
    else bCompleted = new Date(b.CompletedAt).getTime();

    return aCompleted - bCompleted;
  }

  sortNumbers(numA: number, numB: number) {
    var cleanNumA = this.getUndefinedCheck(numA) ? -1 : numA;
    var cleanNumB = this.getUndefinedCheck(numB) ? -1 : numB;
    return cleanNumA - cleanNumB;
  }

  sortString(stringA, stringB) {
    var stringNameA = this.getUndefinedCheckString(stringA) ? "" : stringA;
    var stringNameB = this.getUndefinedCheckString(stringB) ? "" : stringB;
    return stringNameA.localeCompare(stringNameB);
  }

  getUndefinedCheck(value: number): boolean {
    return typeof value === 'undefined' || value === null;
  }

  getUndefinedCheckString(value: string): boolean {
    return value === "" || value === null || typeof value === 'undefined'
  }

  requestAssessment() {
    this.openRequestModal.emit(this.assessment.ID);
  }

  getStatusIconClass(studentAssessment: StudentAssessmentDetails) {
    return studentAssessment.Passed ? "passed" : studentAssessment.Passed === false ? "failed" : "not-taken";
  }

  getStatus(studentAssessment: StudentAssessmentDetails) {
    return studentAssessment.Passed ? "Passed" : studentAssessment.Passed === false ? "Attempted" : "Not taken";
  }

  getCompletedAt(studentAssessment: StudentAssessmentDetails) {
    return studentAssessment.CompletedAt?.toLocaleDateString() ?? "--";
  }

  getNumCorrect(studentAssessment: StudentAssessmentDetails) {
    return studentAssessment.ParsedResults?.QuestionResults?.filter(x => x.SelectedKey === x.TargetKey).length;
  }

  getNumIncorrect(studentAssessment: StudentAssessmentDetails) {
    return studentAssessment.ParsedResults?.QuestionResults?.filter(x => x.SelectedKey !== x.TargetKey).length;
  }

  getNumCorrectText(studentAssessment: StudentAssessmentDetails) {
    return this.getNumCorrect(studentAssessment) ?? "--";
  }

  getNumIncorrectText(studentAssessment: StudentAssessmentDetails) {
    return this.getNumIncorrect(studentAssessment) ?? "--";
  }

  getCorrectTargetsText(studentAssessment: StudentAssessmentDetails) {
    var correctTargets = studentAssessment.ParsedResults?.QuestionResults?.filter(x => x.SelectedKey === x.TargetKey).map(x => x.TargetKey);
    return (correctTargets && correctTargets.length > 0) ? correctTargets.join(" ") : "--";
  }

  getMissedTargetsText(studentAssessment: StudentAssessmentDetails) {
    var incorrectTargets = studentAssessment.ParsedResults?.QuestionResults?.filter(x => x.SelectedKey !== x.TargetKey).map(x => x.TargetKey);
    return (incorrectTargets && incorrectTargets.length > 0) ? incorrectTargets.join(" ") : "--";
  }

  getMissedTargetsClass(studentAssessment: StudentAssessmentDetails) {
    var incorrectTargets = studentAssessment.ParsedResults?.QuestionResults?.filter(x => x.SelectedKey !== x.TargetKey).map(x => x.TargetKey);
    return (incorrectTargets && incorrectTargets.length > 0) ? "results-tooltip-incorrect" : "";
  }
}
